abstract class Panel extends Widget {
    protected constructor(identifier: string, content: string, container: JQuery, controller: Controller, mode: string, defaultAction: Action = Action.NONE) {
        super(identifier, defaultAction, controller, container, mode);
    }

    newState () {
        return new PanelState();
    }

    setState(panelState: PanelState) {
        this.setChildrenStates(panelState)
    }

    getState() {
        var result = new PanelState();

        result.childrenStates = this.getChildrenStates();

        return result;
    }

    previewState(nextState: WidgetState, timeRatioLeft: number) {
        this.previewChildrenStates(nextState, timeRatioLeft);
    }

    removePreviewState() {
        this.removePreviewChildrenStates();
    }
}
